// LANGUAGE
export function generatePointsArray(size: number, start: number) {
    return [''].concat(Array.from({ length: size }, (_, index) => String(index + start)).reverse());
}

export const getLanguageScoresNewFormat = (testType: string) => {
    if (testType === 'IELTS') {
        return generatePointsArray(1, 9);
    } else if (testType === 'CELPIP') {
        return generatePointsArray(1, 12);
    } else if (testType === 'TOEFL') {
        return generatePointsArray(1, 30);
    } else if (testType === 'TEF') {
        return generatePointsArray(121, 294);
    } else if (testType === 'TCF') {
        return generatePointsArray(100, 600);
    } else if (testType === 'CEFR') {
        return generatePointsArray(1, 6);
    } else {
        return generatePointsArray(1, 9);
    }
};
